/* */ 
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined)
  require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function(key) {
  ArrayProto[UNSCOPABLES][key] = true;
};
